import React from "react";

const HomePage = ({ setCurrentPage }) => {
	const navigateToLanguageTool = () => {
		setCurrentPage("language-tool");
	};

	const navigateToBmrTool = () => {
		setCurrentPage("bmr-tool");
	};

	return (
		<div className='bg-gradient-to-r from-gray-400 to-green-700 min-h-screen w-full py-6 flex flex-col justify-center sm:py-12 items-center'>
			<h1 className='text-4xl font-bold text-center mb-4'>Choose a Tool</h1>
			<div className='flex flex-col w-full max-w-sm'>
				<button
					onClick={navigateToLanguageTool}
					className='mb-4 p-2 bg-blue-500 text-white rounded'
				>
					Language Tool
				</button>
				<button
					onClick={navigateToBmrTool}
					className='p-2 bg-green-500 text-white rounded'
				>
					BMR Tool
				</button>
			</div>
		</div>
	);
};

export default HomePage;
